/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

//components
import {
	Grid,
	Box,
	TextField,
	FormControlLabel,
	Switch,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
//translation
import { useTranslation } from "react-i18next";
//mnemonic values
import Mnemonic from "../../../../../Mnemonics.json";

//hooks
import useAuth from "../../../../../hooks/useAuth";

import { day_month_year } from "../../../../../utils/timezones";

import AutoComplete from "../../../../../components/AutoComplete";

import colors from "../../../../../assets/theme/light/colors";

import "./style.css";
import { GET_ALL_PROJECTS_DROPDOWN } from "../../../../../graphql/project";
import {
	CREATE_TASK,
	GET_ALL_TASKS_DROPDOWN,
	GET_ALL_TASKS_WITH_PROJECT,
} from "../../../../../graphql/task";
import { Field } from "formik";

import { v4 as uuidv4 } from "uuid";
import { useParams } from "react-router-dom";
import useLazyQueryAuth from "../../../../../hooks/useLazyQueryAuth";
import useMutationAuth from "../../../../../hooks/useMutationAuth";
import PaperComponent from "../../../../../components/Modal/PaperComponent";
import useQueryAuth from "../../../../../hooks/useQueryAuth";
import { enqueueSnackbar } from "notistack";
import { GET_ALL_TASK_STATUSES } from "../../../../../graphql/taskStatus";
import Mnemonics from "../../../../../Mnemonics.json";

const Main = ({
	formData,
	employees,
	selectedTask,
	resetFields,
	status,
	tenant,
	fromProfile,
	manager,
	userID,
	fromTimesheet,
	myTime,
	group,
	handleSetEmployeeGuid,
	fromDashboard,
	setProjectGuid,
	taskBillable,
	fromReport,
	fromSelectedTaskFromDashboard,
	mutualDisable,
}) => {
	const { t } = useTranslation();
	const {
		storeUserGuid,
		storeUserTenant,
		storeUserFirstName,
		storeUserLastName,
		userRoles,
		isManager,
		isTimeEntryDescriptionMandatory,
		isEmployee,
	} = useAuth();
	const { isAdmin, isEntelligence, isAppUser, manageTimeEntry } = userRoles;

	const isTenantUser = !isAdmin && !isEntelligence && !isAppUser;
	const user = {
		employeeGuid: storeUserGuid,
		firstName: storeUserFirstName,
		lastName: storeUserLastName,
	};
	const userTimezone = Intl.DateTimeFormat()
		.resolvedOptions()
		.timeZone.split("/")[0];

	const {
		values,
		touched,
		formField,
		errors,
		setFieldValue,
		setTouched,
		editMode,
		synced,
		disabled,
		readOnly,
	} = formData;

	const {
		employee,
		task,
		date,
		description,
		minutes,
		hours,
		project,
		billable,
	} = formField;

	const {
		employee: employeeV,
		task: taskV,
		project: projectV,
		date: dateV,
		minutes: minutesV,
		hours: hoursV,
		billable: billableV,
		description: descriptionV,
	} = values;
	const { eName } = useParams();
	const [fetchProjects, setFetchProjects] = useState(false);
	const [projectsList, setProjectsList] = useState([]);
	const [fetchTasks, setFetchTasks] = useState(false);
	const [tasksList, setTasksList] = useState([]);
	const [taskTextValue, setTaskTextValue] = useState("");
	const [openTaskModal, setOpenTaskModal] = useState(false);
	const [tickedId, setTickedId] = useState(null);
	const [taskStatusGuid, setTaskStatusGuid] = useState(null);
	const [fetchTaskStatus, setFetchTaskStatus] = useState(false);
	const [resourceId, setResourceId] = useState(employeeV);
	const [statusContactsIds, setStatusContactsIds] = useState([]);
	useEffect(() => {
		if (editMode === false) {
			if (
				!isTenantUser ||
				!employees.some((x) => x.employeeGuid === storeUserGuid)
			)
				setFieldValue("employee", null);
			setFieldValue("task", null);
			setFieldValue("project", null);
			setFieldValue("date", new Date());
			setFieldValue("duration", Number(0));
			setFieldValue("description", "");
		}
	}, [resetFields]);

	useEffect(() => {
		if (taskV && !editMode) {
			setFieldValue(billable.name, taskV?.billable ?? false);
		} else if (!editMode) {
			setFieldValue(billable.name, taskBillable);
		}
	}, [taskV, taskBillable]);

	useEffect(() => {
		if (
			!fromReport &&
			((!fromTimesheet && isTenantUser && editMode === false) ||
				editMode === false) &&
			employees.some((x) => x.employeeGuid === storeUserGuid)
		) {
			setFieldValue(employee.name, user);
			if (handleSetEmployeeGuid != null)
				handleSetEmployeeGuid(user?.employeeGuid);
		}
	}, []);
	const { cfunction: createTaskData } = useMutationAuth(
		CREATE_TASK,
		"CreateTask"
	);
	const [fetchTask, setFetchTask] = useState(false);
	const { mfunction: getProjects } = useLazyQueryAuth(
		GET_ALL_PROJECTS_DROPDOWN,
		"GetAllProjects"
	);

	const { data: tasks } = useQueryAuth(GET_ALL_TASKS_DROPDOWN, "GetTasks", {
		variables: {
			model: {
				tenantID: storeUserTenant,
				enableFilters: false,
				onGoingTasks: false,
				projectID: projectV?.projectGuid,
			},
		},
		skip: !projectV?.projectGuid && !fetchTask,
	});
	const { data: tasksStatuses } = useQueryAuth(
		GET_ALL_TASK_STATUSES,
		"GetTaskStatuses",
		{
			variables: {
				model: {
					tenantID: storeUserTenant,
					projectID: projectV?.projectGuid,
				},
			},
			skip: !projectV?.projectGuid && !fetchTaskStatus,
		}
	);

	useEffect(() => {
		if (fetchProjects)
			getProjects(
				{
					variables: {
						model: {
							enableFilters: false,
							tenantID: storeUserTenant,
							userID: storeUserGuid,
							withAtLeastOneTask: true,
						},
					},
				},
				(response) => {
					setProjectsList(
						response.GetAllProjects?.projectsList?.projectViews || []
					);
				}
			);
	}, [fetchProjects]);

	useEffect(() => {
		if (!fromReport && fromProfile && eName) {
			const matchedEmployee = employees.find(
				(option) => option.firstName + " " + option.lastName === eName
			);
			setFieldValue(employee.name, matchedEmployee);
		}
	}, [fromProfile, eName, employees]);

	const { mfunction: getTasks } = useLazyQueryAuth(
		GET_ALL_TASKS_WITH_PROJECT,
		"GetTasks"
	);

	useEffect(() => {
		if (fetchTasks && projectV)
			getTasks(
				{
					variables: {
						model: {
							tenantID: storeUserTenant,
							enableFilters: false,
							onGoingTasks: true,
							userID: storeUserGuid,
							projectID: projectV?.projectGuid,
							timeEntriesCreationAllowed: true,
						},
					},
				},
				(response) => {
					setTasksList(response.GetTasks.tasks || []);
				}
			);
	}, [fetchTasks]);

	useEffect(() => {
		if (selectedTask) {
			setFieldValue(task.name, selectedTask);
			setFieldValue(project.name, selectedTask?.ticket?.project);
			setProjectGuid(selectedTask?.ticket?.project?.projectGuid);
			if (!editMode) setFieldValue(billable.name, selectedTask.billable);
		}
	}, [selectedTask, tasksList?.length]);

	const disableResource =
		disabled ||
		fromProfile ||
		editMode ||
		synced === true ||
		(!isAdmin && !isManager && manageTimeEntry !== "M") ||
		status === Mnemonic.TimesheetStatuses.Approved ||
		(manager !== storeUserGuid &&
			isManager === true &&
			userID !== undefined &&
			userID !== null &&
			userID !== storeUserGuid &&
			!isAdmin) ||
		(tenant !== null && tenant !== undefined && tenant !== storeUserTenant);

	const mutualDisableConditions =
		disabled ||
		synced === true ||
		status === Mnemonic.TimesheetStatuses.Approved ||
		(manager !== storeUserGuid &&
			isManager === true &&
			userID !== undefined &&
			userID !== null &&
			userID !== storeUserGuid &&
			!isAdmin &&
			(projectV !== null
				? !projectV?.projectPermissions?.includes(storeUserGuid)
				: false)) ||
		(tenant !== null && tenant !== undefined && tenant !== storeUserTenant);
	const handleCreateNewTask = () => {
		createTaskData(
			{
				variables: {
					model: {
						title: taskTextValue,
						priority: "Medium",
						description: '<p style="margin:0px"></p>',
						employeeGuid: resourceId?.employeeGuid,
						teamGuid: null,
						reporterGuid: storeUserGuid,
						statusChangeContactsGuids: statusContactsIds.map(
							(id) => id?.employeeGuid
						),
						taskStatusGuid: taskStatusGuid?.taskStatusGuid,
						ticketGuid: tickedId?.ticketGuid,
						estimatedStartDate: null,
						estimatedEndDate: null,
						externalReference: tickedId?.externalReference ?? "",
						customerReferenceProject: "",
						estimatedStartDateString: null,
						estimatedEndDateString: null,
						allowTimeEntry: values[project.name]?.allowTimeEntry,
						billable: values[project.name]?.billable ?? false,
						reportTimeEntryDescription: false,
						isFavorite: false,
						estimatedTime: 0,
						areaGuid: null,
						parentTaskGuid: tickedId?.taskGuid || null,
						userID: storeUserGuid,
						media: [],
						tenantGuid: storeUserTenant,
						mentions: [],
					},
				},
			},
			(response) => {
				const data = response.CreateTask?.task;
				enqueueSnackbar(t("projectForm.createdSuccessfully"), {
					variant: "success",
				});
				setOpenTaskModal(false);
				setTasksList((prevTasks) => [...prevTasks, data]);
				formData.setFieldValue(task.name, data);
				formData.setFieldValue(task.billable, data.billable);
			}
		);
	};
	return (
		<Box>
			<Grid container spacing={1}>
				<Grid container spacing={2}>
					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						xl={12}
						className="flex_space-between_center"
					></Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
						<AutoComplete
							autoFocus={!disableResource}
							options={employees}
							getOptionLabel={(option) =>
								option ? option.firstName + " " + option.lastName : ""
							}
							renderOption={(props, option) => (
								<li {...props} key={uuidv4()}>
									{option.firstName + " " + option.lastName}
								</li>
							)}
							identifier={"employeeGuid"}
							disabled={disableResource}
							value={employeeV}
							onChange={(e, value) => {
								setFieldValue(employee.name, value);

								if (selectedTask !== null)
									setFieldValue(task.name, selectedTask);
							}}
							label={t(employee.label)}
							name={employee.name}
							formData={formData}
							required
						/>
					</Grid>

					<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
						<AutoComplete
							autoFocus={disableResource && (myTime || fromDashboard)}
							options={projectsList}
							getOptionLabel={(option) => (option ? option.title : "")}
							renderOption={(props, option) => (
								<li {...props} key={uuidv4()}>
									{option.title}
								</li>
							)}
							onOpen={() => setFetchProjects(true)}
							onClose={() => setFetchProjects(false)}
							identifier={"projectGuid"}
							value={projectV}
							onChange={(e, value) => {
								setFieldValue(project.name, value);
								setFieldValue(task.name, null);
							}}
							label={t(project.label)}
							name={project.name}
							formData={formData}
							required
							disabled={
								editMode ||
								(!myTime &&
									!fromDashboard &&
									!fromTimesheet &&
									!fromProfile &&
									!fromReport) ||
								//from dashboard with selected task
								fromSelectedTaskFromDashboard ||
								mutualDisableConditions
							}
						/>
					</Grid>

					<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
						<AutoComplete
							options={tasksList}
							onOpen={() => setFetchTasks(true)}
							onClose={() => setFetchTasks(false)}
							disabled={
								(editMode && selectedTask == null) ||
								fromSelectedTaskFromDashboard ||
								(!fromTimesheet &&
									!myTime &&
									!fromDashboard &&
									!fromProfile &&
									!fromReport) ||
								mutualDisableConditions
							}
							getOptionLabel={(option) => (option ? option.title : "")}
							renderOption={(props, option) => (
								<li {...props} key={uuidv4()}>
									{option.title}
								</li>
							)}
							identifier={"taskGuid"}
							value={selectedTask !== null ? selectedTask : taskV}
							onChange={(e, value) => {
								setFieldValue(task.name, value);
							}}
							label={t(task.label)}
							name={task.name}
							formData={formData}
							required
							showDisplayAdd={
								(editMode && selectedTask == null) ||
								fromSelectedTaskFromDashboard ||
								(!fromTimesheet &&
									!myTime &&
									!fromDashboard &&
									!fromProfile &&
									!fromReport) ||
								mutualDisableConditions
									? false
									: true
							}
							handleClickAdd={() => {
								setOpenTaskModal(true);
							}}
							setTextFieldValue={setTaskTextValue}
							disabledAdd={projectV == null}
						/>
					</Grid>
					<Dialog
						disablePortal={true}
						open={openTaskModal}
						PaperComponent={PaperComponent}
						onClose={() => setOpenTaskModal(false)}
						sx={{
							zIndex: 1000000,
						}}
						fullWidth
					>
						<DialogTitle>{t("quickAddTask")}</DialogTitle>
						<DialogContent
							sx={{
								display: "flex",
								flexDirection: "column",
								gap: "10px",
								justifyContent: "center",
							}}
						>
							<AutoComplete
								autoFocus={disableResource && (myTime || fromDashboard)}
								options={tasks?.GetTasks?.tasks?.reduce((acc, task) => {
									if (!task.parentTaskGuid) {
										// Check if parentTaskGuid is null
										acc.push(task);
									}
									return acc;
								}, [])}
								getOptionLabel={(option) =>
									option ? option.title : ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.title}
									</li>
								)}
								onOpen={() => setFetchTask(true)}
								onClose={() => setFetchTask(false)}
								identifier={"taskGuid"}
								value={tickedId}
								onChange={(e, value) => {
									setTickedId(value);
								}}
								label={t("timeEntryForm.Ticket")}
								name={project.name}
								formData={formData}
								required
								disabled={
									editMode ||
									(!myTime &&
										!fromDashboard &&
										!fromTimesheet &&
										!fromProfile &&
										!fromReport) ||
									fromSelectedTaskFromDashboard ||
									mutualDisableConditions
								}
							/>

							<AutoComplete
								autoFocus={disableResource && (myTime || fromDashboard)}
								options={
									tasksStatuses?.GetTaskStatuses?.tasksStatus || []
								}
								getOptionLabel={(option) =>
									option ? option.description : ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.description}
									</li>
								)}
								onOpen={() => setFetchTaskStatus(true)}
								onClose={() => setFetchTaskStatus(false)}
								identifier={"taskStatusGuid"}
								value={taskStatusGuid}
								onChange={(e, value) => {
									setTaskStatusGuid(value);
								}}
								label={t("timeEntryForm.TaskStatus")}
								name={project.name}
								formData={formData}
								required
								disabled={
									editMode ||
									(!myTime &&
										!fromDashboard &&
										!fromTimesheet &&
										!fromProfile &&
										!fromReport) ||
									fromSelectedTaskFromDashboard ||
									mutualDisableConditions
								}
							/>

							<TextField
								label={t("timeEntryForm.Task")}
								fullWidth
								value={taskTextValue}
								variant="standard"
								onChange={(e) => setTaskTextValue(e.target.value)}
							/>

							<AutoComplete
								options={employees}
								getOptionLabel={(option) =>
									option
										? option.firstName + " " + option.lastName
										: ""
								}
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.firstName + " " + option.lastName}
									</li>
								)}
								identifier={"employeeGuid"}
								disabled={disableResource}
								value={resourceId}
								onChange={(e, value) => {
									setResourceId(value);
								}}
								label={t("taskForm.employee.label")}
								name={employee.name}
								formData={formData}
							/>

							<AutoComplete
								options={employees}
								getOptionLabel={(option) =>
									option
										? option.firstName + " " + option.lastName
										: ""
								}
								multiple
								disableCloseOnSelect
								renderOption={(props, option) => (
									<li {...props} key={uuidv4()}>
										{option.firstName + " " + option.lastName}
									</li>
								)}
								identifier={"employeeGuid"}
								disabled={
									isEmployee === Mnemonics.ResourceTypes.External ||
									readOnly ||
									false
								}
								value={statusContactsIds}
								onChange={(e, value) => {
									setStatusContactsIds(value);
								}}
								label={t("taskForm.reporter.label")}
								name={"reporters"}
								formData={formData}
								required={true}
							/>
						</DialogContent>
						<DialogActions>
							<Button
								onClick={() => {
									setOpenTaskModal(false);
									setTaskTextValue("");
								}}
								color="error"
							>
								{t("confirmation.cancel")}
							</Button>

							<Button onClick={handleCreateNewTask} color="info">
								{t("timeEntryForm.save")}
							</Button>
						</DialogActions>
					</Dialog>

					<Grid
						className="timesheet-date"
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						xl={12}
					>
						<LocalizationProvider dateAdapter={AdapterDateFns}>
							<DesktopDatePicker
								fullWidth
								//we can bring back this if we want to bring back timezone customization
								// format={
								// 	day_month_year.includes(userTimezone) === true
								// 		? "dd-MM-yyyy"
								// 		: "MM-dd-yyyy"
								// }
								format={"dd-MM-yyyy"}
								timezone="UTC"
								label={t(date.label)}
								value={dateV}
								disabled={mutualDisableConditions}
								onChange={(newValue) => {
									setFieldValue(date.name, newValue);
								}}
								slotProps={{
									desktopPaper: {
										sx: {
											boxShadow: `${colors.box_shadow_color} 1.95px 1.95px 2.6px !important`,
										},
									},
									dialog: {
										disablePortal: true,
										style: { zIndex: 1000000 },
									},
									textField: {
										size: "medium",
										variant: "standard",
										sx: {
											".Mui-disabled": {
												color: "#636563",
												WebkitTextFillColor: "#636563",
											},
										},

										error: touched[date.name] && errors[date.name],
										helperText:
											touched[date.name] &&
											errors[date.name] &&
											t(errors[date.name]),

										onBlur: (e) =>
											setTouched({
												...touched,
												[date.name]: true,
											}),
									},
									field: { clearable: true },
								}}
								sx={{ width: "100% !important", fontFamily: "poppins" }}
							/>
						</LocalizationProvider>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
						<TextField
							sx={{
								".MuiInputBase-input": { fontSize: "14px !important" },
								".Mui-disabled": { color: "#636563" },
							}}
							variant="standard"
							fullWidth
							required
							disabled={mutualDisable}
							label={t(hours.label)}
							value={hoursV}
							onBlur={(e) => {
								setTouched({ ...touched, [hours.name]: true });
								setFieldValue(hours.name, Number(e.target.value));
							}}
							onChange={(e) => {
								const enteredValue =
									e.target.value === "" ? "0" : e.target.value;

								const numericValue = parseInt(enteredValue, 10);
								const formattedValue = isNaN(numericValue)
									? "00"
									: Math.min(Math.max(0, numericValue), 24)
											.toString()
											.padStart(2, "00");

								// If the entered value is 24, clear the minutes field
								if (formattedValue === 24) {
									setFieldValue(hours.name, "24");
									setFieldValue(minutes.name, "00");
								} else {
									// For other values, format the hours field as before

									setFieldValue(hours.name, formattedValue);
								}
							}}
							error={errors[hours.name]}
							helperText={errors[hours.name] && t(errors[hours.name])}
						/>
					</Grid>
					<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
						<TextField
							sx={{
								".MuiInputBase-input": { fontSize: "14px !important" },
								".Mui-disabled": { color: "#636563" },
							}}
							variant="standard"
							fullWidth
							required
							disabled={mutualDisable || hoursV === "24"}
							label={t(minutes.label)}
							value={minutesV}
							onBlur={(e) => {
								setTouched({ ...touched, [minutes.name]: true });
							}}
							onChange={(e) => {
								const enteredValue = e.target.value;
								const numericValue = parseInt(enteredValue, 10);

								// Check the value of the hours field
								const hoursValue = parseInt(hoursV, 10);

								// If the hours field is 24, disable input for minutes
								if (hoursValue === 24) {
									setFieldValue(minutes.name, "00");
								} else {
									// For other values, format the minutes field as before
									const formattedValue = isNaN(numericValue)
										? "00"
										: Math.min(Math.max(0, numericValue), 60)
												.toString()
												.padStart(2, "00");

									setFieldValue(minutes.name, formattedValue);
								}
							}}
							error={errors[minutes.name]}
							helperText={
								errors[minutes.name] && t(errors[minutes.name])
							}
						/>
					</Grid>
					<Grid
						item
						xs={12}
						sm={12}
						md={4}
						lg={3}
						xl={3}
						display="flex"
						alignItems="end"
						justifyContent="center"
					>
						<Field
							as={FormControlLabel}
							type={billable.type}
							name={billable.name}
							control={
								<Switch
									size="small"
									disabled={mutualDisable}
									checked={billableV}
									onBlur={(e) =>
										setTouched({ ...touched, [billable.name]: true })
									}
									onChange={(e) => {
										setFieldValue(billable.name, e.target.checked);
									}}
									error={
										touched[billable.name] && errors[billable.name]
									}
								/>
							}
							label={t(billable.label)}
						/>
					</Grid>

					<Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={3}>
						<TextField
							sx={{
								".MuiInputBase-input": { fontSize: "14px !important" },
								".Mui-disabled": {
									color: "#636563",
									WebkitTextFillColor: "#636563",
								},
							}}
							required={isTimeEntryDescriptionMandatory}
							variant="standard"
							fullWidth
							label={t(description.label)}
							placeholder={t(description.label)}
							value={descriptionV}
							// required={isTimeEntryDescriptionMandatory === true}
							disabled={mutualDisable}
							multiline
							onBlur={(e) =>
								setTouched({ ...touched, [description.name]: true })
							}
							onChange={(e) => {
								setFieldValue(description.name, e.target.value);
							}}
							error={
								touched[description.name] && errors[description.name]
							}
							helperText={
								touched[description.name] &&
								errors[description.name] &&
								t(errors[description.name])
							}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
};

export default Main;
